import { post } from "@utils/fetch";

type CreateOrganizationFromDiscoveryInput = {
  intermediateToken: string;
  organizationName: string;
  organizationDomain: string;
  memberName: string;
};

type CreateOrganizationFromDiscoveryResponse = {
  data: {
    sessionToken: string;
    slug: string;
  };
};

export const createOrganizationFromDiscovery = async (
  input: CreateOrganizationFromDiscoveryInput,
): Promise<CreateOrganizationFromDiscoveryResponse> => {
  const { data } = await post(
    "/api/public/v1/organizations/create-from-discovery/",
    input,
  );

  return data;
};
